import React from "react";
import PropTypes from "prop-types";

import { icons } from "./assets";

import styled from "@emotion/styled";

var ScoreImg = styled.img({
  display: "block"
});

export var ScoreDisplay = function ScoreDisplay(props) {
  return React.createElement(ScoreImg, {
    style: { width: props.height, height: props.height },
    onClick: props.onClick,
    alt: "Score: " + props.score,
    src: icons[props.score]
  });
};

ScoreDisplay.props = {
  score: PropTypes.number,
  onClick: PropTypes.func
};

export default ScoreDisplay;